import {Pipe, PipeTransform} from '@angular/core';

/**
 *
 */
@Pipe({name: 'userNameSwitch'})
export class UserNameSwitchPipe implements PipeTransform {
  /**
   *
   * @param value
   * @returns {string}
   */
  transform(value: string): string {
    const nameArr = value ? value.split('-') : '';
    if (nameArr) {
      return nameArr[1] + ', ' + nameArr[0];
    } else {
      return '';
    }
  }
}
